








import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';

@Component({
  name: 'JobWorkerOfferWorkerAcceptanceStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	offer: JobWorkerOfferDto;

	get pendingConfirmation() {
		return (!this.offer.workerAcceptedById && !this.offer.workerDeclinedById);
	}

	get confirmed() {
		if (this.offer.workerAcceptedById) {
			return true;
		}
		return false
	}

	get declined() {
		if (this.offer.workerDeclinedById) {
			return true;
		}
		return false
	}
}
